module.exports = __webpack_public_path__ + "c2efe53726c59a84af29e47ee626e783.png";